import { render, staticRenderFns } from "./IdentityUserInfoPage.vue?vue&type=template&id=7aafefd6"
import script from "./IdentityUserInfoPage.vue?vue&type=script&lang=js"
export * from "./IdentityUserInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports